import { IconProps } from './types';

export const HeartIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.549 15.355'>
    <path
      // eslint-disable-next-line max-len
      d='M15.845,3.3a4.687,4.687,0,0,0-6.4.466l-.675.7-.675-.7A4.687,4.687,0,0,0,1.7,3.3a4.922,4.922,0,0,0-.339,7.126L8,17.271a1.075,1.075,0,0,0,1.553,0l6.632-6.848A4.918,4.918,0,0,0,15.845,3.3Z'
      transform='translate(0.001 -2.248)'
      fill='#fff'
      {...props}
    />
  </svg>
);
